<template>
    <ContentOrLoading>
        <div v-if="!loading">
            <PageTitle :title="$t('eventos_productos.title')"/>
            <FirstBanner/>
            <div v-if="eventos?.eventos_deportivos?.length > 0">
                <h1 style="text-align: center; margin-top: 20px;">{{ $t('eventos_productos.partidos') }}</h1>
                <ListadoEventosClubs
                    :eventos="eventos.eventos_deportivos"
                    :productos="true"
                />
            </div>
            <div v-if="eventos?.eventos_espectaculos?.length > 0" style="margin-top: -35px;">
                <h1 style="text-align: center;">{{ $t('home.eventos') }}</h1>
                <div>
                    <ListadoEventosImagen
                        :eventos="eventos.eventos_espectaculos"
                        :productos="true"
                        @recargar="getEventosProductos()"
                    />
                </div>
            </div>
            <div v-if="eventos?.eventos_espectaculos?.length === 0 && eventos?.eventos_deportivos?.length === 0" class="text-center padding-content">
                <h3>
                    {{ $t('productos.no_hay_eventos') }}
                </h3>
            </div>
        </div>
    </ContentOrLoading>
</template>


<script>
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import FirstBanner from '@/components/frontend/shared/FirstBanner';
    import ListadoEventosImagen from '@/components/frontend/events/listado/ListadoEventosImagen';
    import ListadoEventosClubs from '@/components/frontend/events/listado/ListadoEventosClubs.vue';
    import { useHead } from '@/composables/common/seo/useHead';

    export default {
        created() {
            useHead('Productos');

            if(this.footer.ocultar_productos || !this.footer.activar_productos) {
                this.$router.push({ name: 'front.home'});
            }
            this.getEventosProductos()
        },
        computed : {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
        },
        data(){
            return {
                eventos: null,
                loading: false
            }
        },
        methods: {
            getEventosProductos : function() {
                this.loading = true;
                const params = {
                    filters : {
                        tid : this.configuracion.hash_teatro,
                    }
                }

                this.$store.dispatch(this.config.getVuexAlias('front.productos.listado-eventos.index'), params).then(res => {
                    this.eventos = res.data;
                }).catch(error => {
                    this.$router.push({name: "front.error", params: {error: "getEventos"}});
                }).finally(() => {
                    this.loading = false;
                });
            },
        },
        components: {
            PageTitle, FirstBanner, ListadoEventosImagen, ListadoEventosClubs
        }
    }
</script>